export { fetchLastWatched } from './fetchLastWatched';
export { getLastWatched } from './getLastWatched';
export { useLastWatched } from './useLastWatched';
export { onUpdateLastWatched } from './onUpdateLastWatched';
export { prefetchLastWatchedQuery as prefetchLastWatched } from './queries';

export * from './types';
